const provisionalOfferSelector = status => status.builder.ui.provisionalOffer;

export default provisionalOfferSelector;
